import { Button, ButtonProps } from 'primereact/button';
import { useTranslation } from 'react-i18next';

type CalculatePcfButtonProps = ButtonProps;

const CalculatePcfButton = (props: CalculatePcfButtonProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Button
      className='max-w-fit flex'
      label={t('productDetailsPage.tabs.pcfTab.buttons.calculatePcfButton')}
      {...props}
    />
  );
};

export default CalculatePcfButton;
